"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrimitiveType = (name) => name === 'string' ||
    name === 'uint8' ||
    name === 'uint16' ||
    name === 'uint32';
